import type { SVGProps } from 'react'

const GeoDataMonitorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <path
      d="M41.8904 57.7184C48.823 57.7184 54.443 52.0984 54.443 45.1658C54.443 38.2332 48.823 32.6133 41.8904 32.6133C34.9579 32.6133 29.3379 38.2332 29.3379 45.1658C29.3379 52.0984 34.9579 57.7184 41.8904 57.7184Z"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.9648 45.7891L36.8687 48.2996L35.6135 52.693L36.8687 56.4587"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.1671 55.8311L47.5395 52.693L44.4014 51.4377V47.0443L48.1671 45.7891L53.8158 46.4167"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.6763 37.0039L50.0487 38.8868L45.6553 39.5144V43.2802L48.7934 42.0249H51.3039L53.8144 43.2802"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.9648 43.2816L33.103 40.7711L36.2411 40.1435L38.7516 36.3777L37.4964 33.8672"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.2361 57.6283H15.5557C10.0328 57.6283 5.55566 53.1512 5.55566 47.6283V44.3791V12.2227C5.55566 6.69981 10.0328 2.22266 15.5557 2.22266H38.9166C44.4395 2.22266 48.9166 6.69981 48.9166 12.2227V29.9255"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8047 24.8299L20.6713 18.9637C21.8429 17.7922 23.7423 17.7923 24.9139 18.9638L27.347 21.397C28.5186 22.5685 30.4181 22.5685 31.5896 21.397L40.1975 12.7891M40.1975 12.7891H32.21M40.1975 12.7891V21.2534"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default GeoDataMonitorIcon
